import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue'
  import TestimonialSlider from '@/components/course/TestimonialSlider.vue'
  import useIcons from '@/composables/useIcons'
  import useCourse from '@/composables/useCourse'
  import useSegment from '@/composables/useSegment'
  import { CourseModule } from '@/store/modules/course'
  import SVGRenderer from '@/components/common/SVGRenderer.vue'
  import { useRoute } from 'vue-router/composables'
  import useShopifyClient from '@/composables/useShopifyClient'
  import LoadingSpinner from '@/components/common/LoadingSpinner.vue'

  
export default /*#__PURE__*/_defineComponent({
  __name: 'NonFreeLesson',
  props: {
    currentLessonTitle: {
      type: String,
      required: true,
    },
    lessonCourseId: String,
  },
  setup(__props) {

const props = __props;

  

  const route = useRoute()
  const { arrowRight } = useIcons()
  const { currentCourseId } = useCourse()
  const { coursePurchaseIntended } = useSegment()
  const { createShopifyCheckout } = useShopifyClient()

  const loadingCourse = computed(() => course.value === null)
  const isSearching = computed(() => !!route.query.q)

  const course = computed(() => {
    return CourseModule.course
  })

  const courseTestimonials = computed(() => {
    return course.value?.testimonials || []
  })

  const trackCoursePurchaseIntended = () => {
    coursePurchaseIntended(currentCourseId.value, course.value!.title, 'lesson_view_cta')
  }

  const shopifyCheckout = async () => {
    trackCoursePurchaseIntended()
    await createShopifyCheckout()
  }

  if ((props.lessonCourseId || course.value?.id) && isSearching.value) {
    CourseModule.getCourse({ courseId: course.value ? course.value.id : props.lessonCourseId! })
  }

return { __sfc: true,props, route, arrowRight, currentCourseId, coursePurchaseIntended, createShopifyCheckout, loadingCourse, isSearching, course, courseTestimonials, trackCoursePurchaseIntended, shopifyCheckout, computed, TestimonialSlider, useIcons, useCourse, useSegment, CourseModule, SVGRenderer, useRoute, useShopifyClient, LoadingSpinner }
}

})